import { Dispatch, SetStateAction, useState } from 'react';

import { ICompanyPart, IPricing } from 'partsOld/types';

import PricingTabView from './PricingTabView';

interface IProps {
  part: Partial<ICompanyPart>;
}

const PricingTab = ({ part }: IProps) => {
  const [selectedPrice, setSelectedPrice] = useState();

  const onRowClick = (row) => setSelectedPrice(row);

  return (
    <PricingTabView
      part={part}
      selectedPrice={selectedPrice}
      setSelectedPrice={setSelectedPrice as unknown as Dispatch<SetStateAction<IPricing>>}
      onRowClick={onRowClick}
    />
  );
};

export default PricingTab;
